export function distance(day) {
    //过去的时间戳
    // var now = new Date(day * 1000);
    var now = new Date(day * 1000);
    //现在的时间
    var today = new Date()
        //过去
        //年
    var year = now.getFullYear();
    //月
    var month = now.getMonth() + 1;
    //日
    var date = now.getDate();
    //时
    var hour = now.getHours();

    //分
    var minute = now.getMinutes();
    //秒
    var second = now.getSeconds();

    //现在
    //年
    var todayyear = today.getFullYear();
    //月
    var todaymonth = today.getMonth() + 1;
    //日
    var todaydate = today.getDate();
    //时
    var todayhour = today.getHours();
    //分
    var todayminute = today.getMinutes();
    //秒
    var todaysecond = today.getSeconds();

    var timer = ''
    //判断
    if(todayyear > year){
        // 一年前
        timer = (todayyear-year)+'年前'
    }else if(todayyear == year){
        if(todaymonth > month){
            timer = (todaymonth-month)+'月前'
        }else if(todaymonth == month){
            if(todaydate > date){
                timer = (todaydate-date)+'天前'
            }else if(todaydate == date){
                if(todayhour > hour){
                    timer = (todayhour-hour)+'小时前'
                }else if(todayhour == hour){
                    if(todayminute > minute){
                        timer = (todayminute-minute)+'分钟前'
                    }else if(todayminute == minute){
                        timer = '刚刚'
                    }
                }
            }
        }
    }
    
    return timer
}


// WEBPACK FOOTER //
// ./src/util/gettime.js